export enum AccessRole {
  USER = '1',
  ADMIN = '3',
  SUPERVISOR = '4',
}
